import React, { FC } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import s from './WhyAngular.scss';
import { ILPWhyAngularData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';
import { i18n } from '../../../../../symphony';

type Props = {
	data: ILPWhyAngularData;
	alias: string;
};

export const WhyAngular: FC<Props> = ({ data, alias }) => {
	useStyles(s);
	return (
		<div className="why-angular">
			<div className="why-angular__container">
				<h4 className="why-angular__title">
					{i18n.t(`web-lelp.${alias}-why-angular-title`)}
				</h4>
				<p
					className="why-angular__description"
					dangerouslySetInnerHTML={{
						__html: i18n.t(
							`web-lelp.${alias}-why-angular-description`,
						),
					}}
				/>
				<div className="why-angular__items-container">
					{data.items.map((item, index) => (
						<div className="why-angular__item" key={item.imgUrl}>
							<img
								className="why-angular__image"
								src={item.imgUrl}
								alt=""
							/>
							<span className="why-angular__item-title">
								{i18n.t(
									`web-lelp.${alias}-why-angular-item${index}-title`,
								)}
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
